// ** Router Import
import Router from './router/Router'
import { useLayoutEffect } from "react"
import Web3 from "web3"
const App = () => {

  useLayoutEffect(() => {
    if (!window.web3Instance) {

      //initiate web3 instance globally 
      const httpProvider = new Web3.providers.HttpProvider(process.env.REACT_APP_WEB3_HTTP_PROVIDER)
      const web3 = new Web3(httpProvider)
      window.web3Instance = web3
    }
  }, [])

  return (< Router />)

}
export default App
